import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import CardChartsLiner from './chartLiner/index'
import { useSelector } from "react-redux";
import CardNodata from './../../../../../common/cardNoData';
// import LineCHarts from './../../../../../common/charts/lineChart';
import LineCHarts from './chartLiner';



let useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        width: '59%',
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
        borderRadius: 10,
        backgroundColor: 'rbg(255,255,255)',
        padding: '45px 30px',
        minHeight: 600,
        height: 600,
        padding: '45px 30px',
        [theme.breakpoints.down("1100")]: {
            width: '100%',
            minHeight: 'auto',
            overflow:'auto'
          },
    },
    title: {
        fontSize: "1.125rem",
        fontWeight: 'bold',
        marginBottom: 20,
    },
    gridLoading: {
        position: 'absulote',
        top: 0,
        width: '100%',
        height: 550,
        backgroundColor: 'rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}))

export default function Index({ }) {

    let classes = useStyles();

    const [state, setstate] = useState({
        data: [],
        keys: []
    });


    const stateReducer = useSelector(state => state?.report_trade_detail_reducer)



    let sortedDate = (array) => {

        let reslute = array.sort(function (a, b) {
            let bb = new Date(b?.x)
            let aa = new Date(a?.x);
            return bb - aa
        });
        return reslute ? reslute : []
    }

    useEffect(() => {
        if (stateReducer?.data?.length) {
            let data = []
            let categoriData = {}
            let res = stateReducer?.data?.forEach((item) => {
                let a = Object.keys(item)
                    ?.forEach((child) => {
                        let elem = item?.[child]
                        let x = item[child]?.forEach((chart) => {
                            let { manufacturer_detail, ...rest } = chart?.body
                            let listKeys = Object.keys(rest)
                            let b = listKeys?.forEach((key) => {
                                if (key !== 'trade_date') {
                                    data.push({
                                        id: key + "_name_" + child,
                                        x: chart?.body?.[key],
                                        y: chart?.body?.['trade_date'],
                                        name: elem?.[0] ? elem?.[0]?.body?.manufacturer_detail?.persianName : child,
                                    })
                                }
                            })
                        })
                    }
                    )
            })
   
            let KeysPersian = {
                'offer_base_price': 'قیمت پایه',
                'final_weighted_average_price': 'عرضه کننده',
                'offer_volume': 'حجم',
                'minimum_price':'پایین ترین قیمت',
                'maximum_price':'بالاترین قیمت'
            }

            let c = data?.forEach((item) => {
                categoriData[item?.id] = {
                    id: `${item?.name} ${KeysPersian?.[item?.id?.split('_name_')?.[0]] ? "(" + KeysPersian?.[item?.id?.split('_name_')?.[0]] + ")" : ''}`,
                    color: '',
                    name: item?.name,
                    data: sortedDate(
                        (categoriData?.[item?.id]?.data ? categoriData?.[item?.id]?.data : []).concat([
                            {
                                x: new Date(`${item?.y} 00:00:00`),
                                y: item?.x
                            },
                        ]))?.reverse()
                }
            })

            if (Object.keys(categoriData)?.length) {
                setstate({ data: Object.keys(categoriData)?.map((key) => categoriData[key]), keys: [] })
            }
        }

    }, [stateReducer.data]);



    return (
        <div className={classes['root']}>
            {
                stateReducer?.loading && (
                    <div className={classes['gridLoading']}>
                        <CircularProgress />
                    </div>
                )
            }
            {
                state?.data?.length !== 0 && (
                    <>
                        {
                            !stateReducer?.loading && (
                                <LineCHarts data={state?.data} />
                            )
                        }
                    </>
                )
            }
            {
                state?.data?.length === 0 && (
                    <>
                        <div>
                            <h3 className={classes['title']}>
                                نمودار :
                            </h3>

                            <CardNodata
                                text={'داده ای یافت نشد'}
                            />


                        </div>
                    </>
                )
            }

        </div>)
}
